<!--
 * @Author: fengzhongmei
 * @Date: 2020-04-23 17:41:15
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-31 16:58:44
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <Modal v-model="modal"
           :title="$t('配置用户')"
           width="600"
           :mask-closable="false"
           @on-cancel="cancel">
        <div class="users">
            <Transfer :data="data"
                      :titles="titles"
                      :target-keys="currData"
                      :list-style="listStyle"
                      filterable
                      :filter-method="filterMethod"
                      @on-change="handleChange"></Transfer>
        </div>
        <Form ref="form"
              :model="formData"
              :rules="rules"
              :label-width="0">
            <FormItem prop="role"
                      style="margin:0 0 0 0;">
                <CheckboxGroup v-model="formData.roleIds">
                    <Checkbox :label="item.groupSid"
                              v-for="(item,i) in roleData"
                              :key="i">{{$t(item.groupName)}}</Checkbox>
                </CheckboxGroup>
            </FormItem>

        </Form>
        <div slot="footer">
            <Button type="text"
                    @click="cancel">{{$t('取消')}}</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="submit">{{loading ? $t('提交中'):$t('保存')}}</Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api'
export default {
    name: 'configureusers',
    data () {
        return {
            modal: false,
            loading: false,
            titles: [this.$t('未选择'), this.$t('已选择')],
            listStyle: {
                width: '250px',
                height: '300px'
            },
            currData: [],
            data: [],
            editData: [],
            formData: {
                roleIds: []
            },
            roleData: [],
            rules: {}
        }
    },
    methods: {
        openModal (data) {
            this.editData = data
            this.modal = true
            if (this.editData.orgSid) {
                this.getDetails()
            }
            this.initUsers()
            this.getUserGroup()
            // 编辑
            if (data) {
                // 右侧数据
                this.currData = []
                if (data.users) {
                    for (let i = 0; i < data.users.length; i++) {
                        this.currData.push(data.users[i].id)
                    }
                }
            }
        },
        // 用户
        initUsers () {
            this.data = []
            this.axios.get(this.urlFormat(API.GET_ACCESS_SUBUSER, false), { params: { inProject: false, includeParent: true } }).then(res => {
                this.loading = false
                for (let i = 0; i < res.length; i++) {
                    this.data.push({
                        key: res[i].userSid,
                        label: res[i].account ? res[i].account : '',
                        description: res[i].orgName ? res[i].orgName : '',
                        disabled: res[i].status !== '1'
                    })
                }
            }).catch(e => {
                this.loading = false
            })
        },
        // 详情
        getDetails () {
            this.currData = []
            this.formData.roleIds = []
            this.axios.get(this.urlFormat(API.ACCESS_PROJECTS_ID, false, [this.editData.orgSid])).then(res => {
                this.loading = false
                if (res.configUsers) {
                    for (let i = 0; i < res.configUsers.length; i++) {
                        this.currData.push(res.configUsers[i].userSid)
                    }
                }
                if (res.configUserGroups) {
                    for (let i = 0; i < res.configUserGroups.length; i++) {
                        this.formData.roleIds.push(res.configUserGroups[i].groupSid)
                    }
                }
            }).catch(e => {
                this.loading = false
            })
        },
        // 用户组
        getUserGroup () {
            this.roleData = []
            this.axios.get(this.urlFormat(API.GET_USER_GROUP, false), {
                params: {
                    includeDefaultGroup: true
                }
            }).then(res => {
                this.loading = false
                this.roleData = res
            }).catch(e => {
                this.loading = false
            })
        },
        handleChange (newTargetKeys) {
            this.currData = newTargetKeys
        },
        filterMethod (data, query) {
            return data.label.indexOf(query) > -1
        },
        // 提交
        submit () {
            const params = {
                orgSid: this.editData.orgSid
            }
            if (this.currData.length > 0) {
                params.userIds = this.currData
            }
            if (this.formData.roleIds.length > 0) {
                params.userGroupIds = this.formData.roleIds
            }
            this.$refs.form.validate((v) => {
                if (v) {
                    this.loading = true
                    this.axios.put(this.urlFormat(API.PUT_ACCESS_PROJECTS_RELATE, false), params).then(res => {
                        this.loading = false
                        this.$emit('refresh')
                        this.cancel()
                    }).catch(e => {
                        this.loading = false
                    })
                }
            })
        },
        // 清空数据
        cancel () {
            this.$refs.form.resetFields()
            this.currData = []
            this.data = []
            this.editData = []
            this.formData.roleIds = []
            this.modal = false
        }
    }
}
</script>
<style lang="less" scoped>
.users {
    margin: 0px 0 15px 0;
}
</style>
